import { Link } from "react-router-dom";

export default function Header() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-40 bg-brand-bg/85 backdrop-blur-md border-b border-brand-line" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-3 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <img
            src="/logo-24vox.jpg"
            alt="24Vox"
            className="h-14 w-14 rounded-lg object-contain bg-[#0a0a14] p-1"
          />
          <span className="font-heading text-2xl font-bold text-brand-ink tracking-tight hidden sm:block">
            24<span className="text-brand-terra">Vox</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/come-funziona" className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="nav-how">
            Come funziona
          </Link>
          <button onClick={() => scrollTo("pricing")} className="text-brand-inkSoft hover:text-brand-ink transition-colors" data-testid="nav-pricing">
            Prezzi
          </button>
          <Link
            to="/team-ai"
            className="text-brand-inkSoft hover:text-brand-ink transition-colors"
            data-testid="nav-team-ai"
          >
            Il Team AI
          </Link>
          <a
            href="/dashboard"
            className="px-4 py-2 border border-brand-olive text-brand-olive rounded-full hover:bg-brand-olive hover:text-brand-bg transition-colors text-sm"
            data-testid="nav-access"
          >
            Accedi
          </a>
        </nav>
        <button
          onClick={() => scrollTo("hero")}
          className="md:hidden text-sm text-brand-olive font-medium"
          data-testid="nav-mobile-cta"
        >
          Provala
        </button>
      </div>
    </header>
  );
}
